import React from "react";
import TextField, { TextFieldProps } from "@mui/material/TextField";
import { Stack, Typography, TypographyProps } from "@mui/material";

export type WcViewEditTextFieldProps = TextFieldProps & {
  controlDisabled?: boolean;
  useFullWidth?: boolean;
  size?: string;
  placeholder?: string;
  hoverColor?: string;
  width?: string | number;
  editModeOutSide?: boolean;
  placeholderHeight?: number | string;
  typographyProps?: TypographyProps;
  onLeave?: () => void;
};

export const WcViewEditTextField = ({
  size = "small",
  useFullWidth = true,
  controlDisabled,
  variant = "filled",
  value,
  sx,
  placeholder = "",
  hoverColor,
  width,
  editModeOutSide,
  placeholderHeight = 28,
  typographyProps,
  onLeave,
  ...props
}: WcViewEditTextFieldProps) => {
  const [editMode, setEditMode] = React.useState(editModeOutSide || false);

  React.useEffect(() => {
    if (value) {
      //@ts-ignore
      setLocalValue(value.toString());
    }
  }, [value]);

  const [localValue, setLocalValue] = React.useState<unknown>("");

  return (
    <Stack
      sx={{
        cursor: "pointer",
        ":hover": { backgroundColor: !editMode ? hoverColor : undefined },
      }}
      onClick={() => {
        if (!editMode) {
          setEditMode(true);
        }
      }}
      onBlur={() => {
        setEditMode(false);
      }}
      width={width ? width : "100%"}
      id="ViewEditTextField"
      padding={1}
    >
      {editMode && (
        <TextField
          inputProps={{ readOnly: controlDisabled }}
          fullWidth={useFullWidth ? useFullWidth : false}
          disabled={controlDisabled}
          value={value || ""}
          size={size}
          variant={variant}
          onChange={(val) => setLocalValue(val)}
          autoFocus
          onBlur={(event) => {
            setLocalValue(event.target.value);
            onLeave();
          }}
          sx={[...(Array.isArray(sx) ? sx : [sx])]}
          {...props}
        />
      )}
      {!editMode && localValue && <Typography {...typographyProps}>{localValue.toString()}</Typography>}
      {!editMode && !localValue && (
        <Stack height={placeholderHeight}>
          <Typography {...typographyProps}>{placeholder}</Typography>
        </Stack>
      )}
    </Stack>
  );
};

export default WcViewEditTextField;
